class Modal {
  containers = [document.body, document.querySelector('.appContainer')];

  moveModalToFooter(modal) {
    document.body.appendChild(modal);
  }

  displayModalAction(handler, modal) {
    if (handler === 'open') {
      this.containers.map(el => el.classList.add('modalDisplayed'));
      modal.style.display = 'flex';
      modal.classList.add('emodal-active');
    } else {
      handler.addEventListener('click', e => {
        e.preventDefault();
        this.containers.map(el => el.classList.add('modalDisplayed'));
        modal.style.display = 'flex';
        modal.classList.add('emodal-active');
      });
    }
  }

  closeModalAction(modal) {
    this.containers.map(el => el.classList.remove('modalDisplayed'));
    modal.style.display = 'none';
    modal.classList.remove('emodal-active');
  }

  closeModalHandler(modal) {
    modal.addEventListener('click', e => {
      if (!e.target.classList.contains('emodal-active')) return;
      this.closeModalAction(modal);
    });

    modal.querySelector('.emodal-close').addEventListener('click', () => {
      this.closeModalAction(modal);
    });
  }

  init(btnHandler, modal) {
    if (!btnHandler && !modal) return;

    this.moveModalToFooter(modal);
    this.displayModalAction(btnHandler, modal);
    this.closeModalHandler(modal);
  }
}

export default new Modal();
